var _circle, _circle2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 17,
    cy: 17.5,
    r: 17,
    fill: "#00B67A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.5,
    r: 11,
    fill: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5903 14.6318V21.5H16.4097V14.6318H17.5903ZM16.3208 12.8101C16.3208 12.6196 16.3779 12.4588 16.4922 12.3276C16.6107 12.1965 16.7842 12.1309 17.0127 12.1309C17.237 12.1309 17.4084 12.1965 17.5269 12.3276C17.6496 12.4588 17.7109 12.6196 17.7109 12.8101C17.7109 12.992 17.6496 13.1486 17.5269 13.2798C17.4084 13.4067 17.237 13.4702 17.0127 13.4702C16.7842 13.4702 16.6107 13.4067 16.4922 13.2798C16.3779 13.1486 16.3208 12.992 16.3208 12.8101Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.66ea193935df45a65a06f893e70d0a59.svg";
export { ForwardRef as ReactComponent };